export interface SafetyItem {
  id: string;
  /** Equipment / requirement name (e.g. "Life Jackets – 1 Per Person"). */
  name: string;
  /**
   * The inventory item this row checks, when it was picked from the vessel's
   * Safety Equipment. Empty on a row carried over from a log written before the
   * picker, and on one whose equipment has not been created yet — the log
   * itself stores only the name, so the link is remade by name on reload.
   */
  equipmentId: string;
  /**
   * Named through the picker's add control but not in the inventory yet. The
   * item is created in the Safety Equipment category when the log is saved
   * rather than when the row is added, so a row abandoned before Save leaves
   * nothing behind.
   */
  isNewEquipment: boolean;
  /** Combined remarks & compliance note (maps to backend remarks_compliance). */
  remarksCompliance: string;
  /** Time the item was checked / verified (HH:MM). Maps to backend item date. */
  time: string;
  /** Expiration date (ISO string). Maps to backend item expiration. */
  expiration: string;
}

export interface SafetyLogState {
  date: string;
  items: SafetyItem[];
}

export const SAFETY_REQUIREMENTS_NOTE =
  'Decked Vessels no longer than 15m Registered Length. ' +
  'Code of practice for the safety of small vessels. ' +
  'Ensure equipment provided is fit for its intended purpose.';
